// extracted by mini-css-extract-plugin
module.exports =  {"badge":"HnSIeHy","all-caps":"Cnmu9Fi","allCaps":"Cnmu9Fi"};